/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * One reason for every quote in the group, on show and on hide. There is no carrier confirmation: a group spans several quotes from several carriers, so one tick could not speak for them, and the group show only ever touches Sellable and legacy quotes. Anything needing a real confirmation is skipped and shown one at a time.
 * @export
 * @interface QuoteGroupReasonBody
 */
export interface QuoteGroupReasonBody {
  /**
   *
   * @type {string}
   * @memberof QuoteGroupReasonBody
   */
  reason?: string | null;
}

/**
 * Check if a given object implements the QuoteGroupReasonBody interface.
 */
export function instanceOfQuoteGroupReasonBody(
  value: object,
): value is QuoteGroupReasonBody {
  return true;
}

export function QuoteGroupReasonBodyFromJSON(json: any): QuoteGroupReasonBody {
  return QuoteGroupReasonBodyFromJSONTyped(json, false);
}

export function QuoteGroupReasonBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteGroupReasonBody {
  if (json == null) {
    return json;
  }
  return {
    reason: json["reason"] == null ? undefined : json["reason"],
  };
}

export function QuoteGroupReasonBodyToJSON(json: any): QuoteGroupReasonBody {
  return QuoteGroupReasonBodyToJSONTyped(json, false);
}

export function QuoteGroupReasonBodyToJSONTyped(
  value?: QuoteGroupReasonBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    reason: value["reason"],
  };
}
